<template>
  <div class="flex h-full flex-col">
    <topbar title="Accedi" :menu="false" :showBack="true" @back="$router.push({name: 'AuthStart'})" />
    <div class="flex flex-1 flex-col justify-center p-3 mx-auto max-w-2xl w-full ">

      <div class="flex flex-col items-stretch">
        <button class="btn btn-1 my-1" @click="socialRegister('facebook')">
          {{$t('login.login-with-facebook')}}
        </button>
        <button class="btn btn-1 my-1" @click="socialRegister('google')">
          {{$t('login.login-with-google')}}
        </button>
      </div>

      <div class="py-3">
        {{$t('or')}}
      </div>

      <div class="flex flex-col items-stretch">
        <div class="my-2">{{$t('login.login-with-email')}}</div>
        <input class="inp flex-1 p-2 my-2" :class="{faulty: faultyEmail}" autocomplete="username" type="email" v-model="email" :placeholder="$t('form.email.placeholder')">
        <input class="inp flex-1 p-2 my-2" :class="{faulty: faultyPassword}" autocomplete="current-password" type="password" v-model="password" :placeholder="$t('form.password.placeholder')">
      </div>

      <div v-if="error" class="text-red-600 my-2">
        ⚠ {{ $t(`error.${error}`) }}
      </div>

      <div class="flex flex-col items-stretch my-2">
        <button to="/start" class="flex-1 btn btn-1" @click="loginEmail()" :disabled="!(email && password)" >
          {{$t('login.button')}}
        </button>
        <router-link :to="{name: 'EmailRecover'}" class="underline self-end my-2 py-1">
          {{$t('login.forgot-password')}} &gt;
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      error: null,
      email: '',
      password: '',
      faultyEmail: false,
      faultyPassword: false
    }
  },
  components: {
  },
  computed: {
    credentials() {
      return {
        email: this.email,
        password: this.password
      }
    }
  },
  methods: {
    async loginGoogle() {
      try {
        await this.$store.dispatch('loginGoogle')
        this.$router.push({name: 'Overview'})
      } catch(e) {
        console.log(e)
      }
    },
    async socialRegister(providerId) {
      await this.$store.dispatch('loginSocial', providerId)
      this.$router.push({name: 'Overview'})
    },
    async loginEmail() {
      this.error = null
      this.faultyEmail = false
      this.faultyPassword = false

      try {
        await this.$store.dispatch('loginEmail', this.credentials)
        this.$router.push({name: 'Overview'})
      } catch(e) {
        this.error = e.code
        switch (e.code) {
          case 'auth/wrong-password':
            this.faultyPassword = true
            break;
          case 'auth/user-not-found':
            this.faultyEmail = true
            break;
        }
      }
    },
  }
}
</script>

<style lang="stylus" scoped>

</style>